import { render, staticRenderFns } from "./ImsSettingsWidget.vue?vue&type=template&id=780b48bb&"
import script from "./ImsSettingsWidget.vue?vue&type=script&lang=js&"
export * from "./ImsSettingsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports